module.exports = __webpack_public_path__ + "img/plastics-img-2.429e8860.png";